import { render, staticRenderFns } from "./matrixChart.vue?vue&type=template&id=75609c70&scoped=true&"
import script from "./matrixChart.vue?vue&type=script&lang=js&"
export * from "./matrixChart.vue?vue&type=script&lang=js&"
import style0 from "./matrixChart.vue?vue&type=style&index=0&id=75609c70&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75609c70",
  null
  
)

export default component.exports